<template>
    <vxe-modal
        v-model="visible"
        title="执行频次变更申请"
        :width="860"
        :height="600"
        show-zoom
        resize
        remember
        show-footer
    >
        <template #default>
            <a-tabs v-model:activeKey="activeKey">
                <a-tab-pane key="1" tab="申请单">
                    <vxe-form
                        :data="formData"
                        :rules="formRules"
                        title-align="right"
                        ref="rFormChange"
                        title-width="60"
                    >
                        <vxe-form-item
                            title="开发编号"
                            field="ProcessID"
                            span="12"
                            title-width="160px"
                        >
                            <template #default>
                                <vxe-input
                                    v-model="formData.ProcessID"
                                    readonly
                                    disabled
                                ></vxe-input>
                            </template>
                        </vxe-form-item>

                        <vxe-form-item
                            title="数字员工名称"
                            field="ProcessName"
                            span="12"
                            title-width="130px"
                        >
                            <template #default>
                                <vxe-input
                                    v-model="formData.ProcessName"
                                    readonly
                                    disabled
                                ></vxe-input>
                            </template>
                        </vxe-form-item>

                        <vxe-form-item
                            title="原人工每次耗时"
                            field="oldManSingleTime"
                            span="12"
                            title-width="160px"
                        >
                            <template #default>
                                <vxe-input
                                    type="number"
                                    v-model="formData.oldManSingleTime"
                                    readonly
                                    disabled
                                ></vxe-input>
                            </template>
                        </vxe-form-item>

                        <vxe-form-item
                            title="新人工每次耗时"
                            field="ManSingleTime"
                            span="12"
                            title-width="160px"
                        >
                            <template #default>
                                <vxe-input
                                    type="number"
                                    clearable
                                    v-model="formData.ManSingleTime"
                                    placeholder="请输入新人工每次耗时"
                                    :disabled="allInputDisable"
                                ></vxe-input>
                            </template>
                        </vxe-form-item>

                        <vxe-form-item
                            title="原人工每月次数"
                            field="oldManFrequency"
                            span="12"
                            title-width="160px"
                        >
                            <template #default>
                                <vxe-input
                                    type="number"
                                    v-model="formData.oldManFrequency"
                                    readonly
                                    disabled
                                ></vxe-input>
                            </template>
                        </vxe-form-item>

                        <vxe-form-item
                            title="新人工每月次数"
                            field="ManFrequency"
                            span="12"
                            title-width="160px"
                        >
                            <template #default>
                                <vxe-input
                                    type="number"
                                    clearable
                                    v-model="formData.ManFrequency"
                                    placeholder="请输入新人工每月次数"
                                    :disabled="allInputDisable"
                                ></vxe-input>
                            </template>
                        </vxe-form-item>

                        <vxe-form-item
                            title="原开发时长"
                            field="oldDevelopTime"
                            span="12"
                            title-width="160px"
                        >
                            <template #default>
                                <vxe-input
                                    type="number"
                                    v-model="formData.oldDevelopTime"
                                    readonly
                                    disabled
                                ></vxe-input>
                            </template>
                        </vxe-form-item>

                        <vxe-form-item
                            title="新开发时长"
                            field="DevelopTime"
                            span="12"
                            title-width="160px"
                        >
                            <template #default>
                                <vxe-input
                                    type="number"
                                    clearable
                                    v-model="formData.DevelopTime"
                                    placeholder="请输入新开发时长"
                                    :disabled="allInputDisable"
                                ></vxe-input>
                            </template>
                        </vxe-form-item>

                        <vxe-form-item
                            title="原机器人单次耗时"
                            field="oldRobotSingleTime"
                            span="12"
                            title-width="160px"
                        >
                            <template #default>
                                <vxe-input
                                    type="number"
                                    v-model="formData.oldRobotSingleTime"
                                    readonly
                                    disabled
                                ></vxe-input>
                            </template>
                        </vxe-form-item>

                        <vxe-form-item
                            title="新机器人单次耗时"
                            field="RobotSingleTime"
                            span="12"
                            title-width="160px"
                        >
                            <template #default>
                                <vxe-input
                                    type="number"
                                    clearable
                                    v-model="formData.RobotSingleTime"
                                    placeholder="请输入新机器人单次耗时"
                                    :disabled="allInputDisable"
                                ></vxe-input>
                            </template>
                        </vxe-form-item>

                        <vxe-form-item
                            title="原机器人每月次数"
                            field="oldRobotMonthRun"
                            span="12"
                            title-width="160px"
                        >
                            <template #default>
                                <vxe-input
                                    type="number"
                                    v-model="formData.oldRobotMonthRun"
                                    readonly
                                    disabled
                                ></vxe-input>
                            </template>
                        </vxe-form-item>

                        <vxe-form-item
                            title="新机器人每月次数"
                            field="RobotMonthRun"
                            span="12"
                            title-width="160px"
                        >
                            <template #default>
                                <vxe-input
                                    type="number"
                                    clearable
                                    v-model="formData.RobotMonthRun"
                                    placeholder="请输入新机器人每月次数"
                                    :disabled="allInputDisable"
                                ></vxe-input>
                            </template>
                        </vxe-form-item>

                        <vxe-form-item
                            title="变更原因"
                            field="changeReason"
                            span="24"
                            title-width="120px"
                        >
                            <template #default>
                                <vxe-textarea
                                    rows="4"
                                    v-model="formData.changeReason"
                                    placeholder="请输入变更原因"
                                    maxlength="1000"
                                    show-word-count
                                    :disabled="allInputDisable"
                                ></vxe-textarea>
                            </template>
                        </vxe-form-item>

                        <vxe-form-item
                            title="注意："
                            span="24"
                            title-width="120px"
                        >
                            <template #default>
                                <span class="notice-text">
                                    信息变更申请提交后，需要审核通过后才会更新正式上岗信息，请确认变更内容准确。
                                    <br />最大变更次数{{
                                        maxCount
                                    }}次，请谨慎操作
                                </span>
                            </template>
                        </vxe-form-item>
                    </vxe-form>
                </a-tab-pane>

                <a-tab-pane key="2" tab="申请历史">
                    <vxe-table
                        stripe
                        class="mytable-scrollbar"
                        :data="historyData"
                        :height="330"
                        show-overflow
                        :row-config="{
                            height: 36,
                            isHover: true,
                            isCurrent: true,
                        }"
                    >
                        <vxe-column
                            type="seq"
                            title="序号"
                            width="50"
                        ></vxe-column>
                        <vxe-column title="操作" width="50" show-overflow>
                            <template #default="{ row }">
                                <vxe-button
                                    type="text"
                                    icon="fa fa-pencil-square"
                                    @click="editReject(row)"
                                    v-if="row.statusName === '已驳回'"
                                ></vxe-button>
                            </template>
                        </vxe-column>
                        <vxe-column
                            field="statusName"
                            title="状态"
                            width="120"
                            show-overflow
                        >
                            <template #default="{ row }">
                                <vxe-button
                                    v-bind:class="{
                                        active: row.statusName === '已审核',
                                        error: row.statusName.includes('驳回'),
                                    }"
                                    type="text"
                                    @click="showAuditList(row)"
                                    >{{ row.statusName }}
                                </vxe-button>
                            </template>
                        </vxe-column>

                        <vxe-column
                            field="ProcessName"
                            title="数字员工名称"
                            width="180"
                            show-overflow
                        ></vxe-column>

                        <vxe-column
                            field="ProcessID"
                            title="开发编号"
                            width="130"
                            show-overflow
                        ></vxe-column>
                        <vxe-column
                            field="oldManSingleTime"
                            title="原人工每次耗时"
                            width="150"
                            show-overflow
                        ></vxe-column>

                        <vxe-column
                            field="ManSingleTime"
                            title="新人工每次耗时"
                            width="150"
                            show-overflow
                        ></vxe-column>

                        <vxe-column
                            field="oldManFrequency"
                            title="原人工每月次数"
                            width="150"
                            show-overflow
                        ></vxe-column>

                        <vxe-column
                            field="ManFrequency"
                            title="新人工每月次数"
                            width="150"
                            show-overflow
                        ></vxe-column>

                        <vxe-column
                            field="oldDevelopTime"
                            title="原开发时长"
                            width="150"
                            show-overflow
                        ></vxe-column>

                        <vxe-column
                            field="DevelopTime"
                            title="新开发时长"
                            width="150"
                            show-overflow
                        ></vxe-column>

                        <vxe-column
                            field="oldRobotSingleTime"
                            title="原机器人单次耗时"
                            width="150"
                            show-overflow
                        ></vxe-column>

                        <vxe-column
                            field="RobotSingleTime"
                            title="新机器人单次耗时"
                            width="150"
                            show-overflow
                        ></vxe-column>

                        <vxe-column
                            field="oldRobotMonthRun"
                            title="原机器人每月次数"
                            width="150"
                            show-overflow
                        ></vxe-column>

                        <vxe-column
                            field="RobotMonthRun"
                            title="新机器人每月次数"
                            width="150"
                            show-overflow
                        ></vxe-column>

                        <vxe-column
                            field="creationTime"
                            title="创建日期"
                            width="150"
                            show-overflow
                        ></vxe-column>

                        <vxe-column
                            field="UserName"
                            title="申请人"
                            width="100"
                            show-overflow
                        ></vxe-column>

                        <vxe-column
                            field="changeReason"
                            title="变更原因"
                            min-width="200"
                            show-overflow
                        ></vxe-column>
                    </vxe-table>
                </a-tab-pane>
            </a-tabs>
        </template>
        <template #footer v-if="activeKey === '1'">
            <div align="center" span="24">
                <vxe-button
                    @click="visible = false"
                    icon="fa fa-close"
                    status="danger"
                >
                    关闭
                </vxe-button>

                <vxe-button
                    :loading="submitting"
                    @click="submit"
                    icon="fa fa-check"
                    status="primary"
                >
                    提交
                </vxe-button>
            </div>
        </template>
    </vxe-modal>
    <vxe-modal
        title="审核记录"
        v-model="isShowAuditList"
        width="500"
        height="600"
    >
        <template #default>
            <div>
                <MyAuditLine :auditrecord-list="dtAudit"></MyAuditLine>
            </div>
        </template>
    </vxe-modal>
</template>

<script setup>
import MyAuditLine from "../myPlug/MyAuditLine";
import {
    ref,
    reactive,
    defineExpose,
    defineEmits,
    defineProps,
    getCurrentInstance,
    onMounted,
} from "vue";
import { VXETable } from "vxe-table";
import Qs from "qs";
const emit = defineEmits(["flashPubList"]);
const { proxy } = getCurrentInstance();
const activeKey = ref("1");
const submitting = ref(false);
const allInputDisable = ref(false);
const rFormChange = ref();
const historyData = ref([]);

const formData = reactive(getEmptyFormData());
const visible = ref(false);
const isShowAuditList = ref(false);
const dtAudit = ref([]);
const maxCount = ref(0);
const formRules = {
    ManSingleTime: [{ required: true, message: "请输入新人工每次耗时" }],
    ManFrequency: [{ required: true, message: "请输入新人工每月次数" }],
    DevelopTime: [{ required: true, message: "请输入新开发时长" }],
    RobotSingleTime: [{ required: true, message: "请输入新机器人单次耗时" }],
    RobotMonthRun: [{ required: true, message: "请输入新机器人每月次数" }],
    changeReason: [{ required: true, message: "请输入变更原因" }],
};

function getEmptyFormData() {
    return {
        Id: "",
        pubId: "",

        ProcessID: "",
        ProcessName: "",
        DevelopUser: "",

        ManSingleTime: null,
        ManFrequency: null,
        DevelopTime: null,
        RobotSingleTime: null,
        RobotMonthRun: null,

        oldManSingleTime: null,
        oldManFrequency: null,
        oldDevelopTime: null,
        oldRobotSingleTime: null,
        oldRobotMonthRun: null,

        changeType: "1",
        status: "0",
        changeReason: "",
        creationTime: "",
        creator: "",
    };
}

function resetFormData() {
    const emptyData = getEmptyFormData();

    Object.keys(emptyData).forEach((key) => {
        formData[key] = emptyData[key];
    });
}
function showAuditList(row) {
    const params = {
        uid: proxy.$store.state.userID,
        email: proxy.$store.state.email,
        currentPage: 1,
        pageSize: 1,
        searchKey: [row.Id, "1"], //
    };
    proxy.$api.requireManageAPI
        .getAuditRecordList(Qs.stringify(params))
        .then((res) => {
            if (res.data.Success == false) {
                VXETable.modal.message({
                    content: res.data.Message,
                    status: "error",
                });
                return;
            }
            // console.log(res.data.Data);
            dtAudit.value = res.data.Data;
            isShowAuditList.value = true;
        })
        .catch((error) => {
            console.log(error);
        });
}
function init(row) {
    resetFormData();

    activeKey.value = "1";
    submitting.value = false;
    allInputDisable.value = false;
    formData.Id = proxy.$utils.guid();
    formData.pubId = row.Id;
    formData.ProcessID = row.ProcessID || "";
    formData.ProcessName = row.ProcessName || "";

    formData.ManSingleTime = row.ManSingleTime ?? null;
    formData.ManFrequency = row.ManFrequency ?? null;
    formData.DevelopTime = row.DevelopTime ?? null;
    formData.RobotSingleTime = row.RobotSingleTime ?? null;
    formData.RobotMonthRun = row.RobotMonthRun ?? null;

    formData.oldManSingleTime = row.ManSingleTime ?? null;
    formData.oldManFrequency = row.ManFrequency ?? null;
    formData.oldDevelopTime = row.DevelopTime ?? null;
    formData.oldRobotSingleTime = row.RobotSingleTime ?? null;
    formData.oldRobotMonthRun = row.RobotMonthRun ?? null;

    formData.changeType = "1"; //频次变更
    formData.status = "1";
    formData.changeReason = "";
    formData.creator = proxy.$store.state.userID;
    setHistory(row);
    visible.value = true;
}

function setHistory(row) {
    const params = {
        uid: proxy.$store.state.userID,
        email: proxy.$store.state.email,
        currentPage: 1,
        pageSize: 50,
        searchKey: [row.Id, "1"],
    };
    proxy.$api.newPublishManageAPI
        .getPublishInfoChange(Qs.stringify(params))
        .then((res) => {
            if (res.data.Success == false) {
                console.log(res.data.Message);
                return;
            }
            // console.log(res.data.Data);
            historyData.value = Array.isArray(res.data.Data.dataTable)
                ? res.data.Data.dataTable
                : [];
        })
        .catch((error) => {
            console.log(error);
        });
}
const addAuditRecord = (status, type) => {
    let auditBuId = "";
    let auditOpinion = "";
    switch (type) {
        case "1":
            auditBuId = formData.Id;
            auditOpinion = "";
            break;
    }
    //写审核日志
    const params = {
        auditBuId: auditBuId,
        auditMan: proxy.$store.state.userName,
        auditManUid: proxy.$store.state.userID,
        auditStatus: status, //0发起 1 通过 2 驳回
        auditOpinion: auditOpinion,
        auditNode: "审核发起",
    };
    proxy.$api.requireManageAPI
        .addAuditRecord(Qs.stringify(params))
        .then((res) => {
            if (res.data.Success === false) {
                VXETable.modal.message({
                    content: res.data.Message,
                    status: "error",
                });
                return;
            }
        })
        .catch((error) => {
            console.log(error);
        });
};
const getModel = () => {
    const data = new FormData();

    data.append("Id", formData.Id ?? "");
    data.append("pubId", formData.pubId ?? "");

    data.append("ProcessID", formData.ProcessID ?? "");
    data.append("ProcessName", formData.ProcessName ?? "");
    data.append("DevelopUser", formData.DevelopUser ?? "");

    data.append("ManSingleTime", formData.ManSingleTime ?? "");
    data.append("ManFrequency", formData.ManFrequency ?? "");
    data.append("DevelopTime", formData.DevelopTime ?? "");
    data.append("RobotSingleTime", formData.RobotSingleTime ?? "");
    data.append("RobotMonthRun", formData.RobotMonthRun ?? "");

    data.append("oldManSingleTime", formData.oldManSingleTime ?? "");
    data.append("oldManFrequency", formData.oldManFrequency ?? "");
    data.append("oldDevelopTime", formData.oldDevelopTime ?? "");
    data.append("oldRobotSingleTime", formData.oldRobotSingleTime ?? "");
    data.append("oldRobotMonthRun", formData.oldRobotMonthRun ?? "");

    data.append("changeType", formData.changeType ?? "");
    data.append("status", formData.status ?? "");
    data.append("changeReason", formData.changeReason ?? "");
    data.append("creationTime", formData.creationTime ?? "");
    data.append("creator", formData.creator ?? "");

    return data;
};
function editReject(row) {
    if (!row) {
        return;
    }

    formData.Id = row.Id ?? "";
    formData.pubId = row.pubId ?? "";

    formData.ProcessID = row.ProcessID ?? "";
    formData.ProcessName = row.ProcessName ?? "";

    formData.ManSingleTime = row.ManSingleTime ?? "";
    formData.ManFrequency = row.ManFrequency ?? "";
    formData.DevelopTime = row.DevelopTime ?? "";
    formData.RobotSingleTime = row.RobotSingleTime ?? "";
    formData.RobotMonthRun = row.RobotMonthRun ?? "";

    formData.oldManSingleTime = row.oldManSingleTime ?? "";
    formData.oldManFrequency = row.oldManFrequency ?? "";
    formData.oldDevelopTime = row.oldDevelopTime ?? "";
    formData.oldRobotSingleTime = row.oldRobotSingleTime ?? "";
    formData.oldRobotMonthRun = row.oldRobotMonthRun ?? "";

    formData.changeType = row.changeType ?? "";
    formData.status = "1";
    formData.changeReason = row.changeReason ?? "";
    formData.creationTime = row.creationTime ?? "";
    formData.creator = row.creator ?? "";

    // 如果你有弹窗，可以在这里打开
    activeKey.value = "1";
}
async function submit() {
    if (!rFormChange.value) {
        return;
    }

    const errMap = await rFormChange.value.validate().catch((errMap) => errMap);

    if (errMap) {
        return;
    }

    const noChange =
        String(formData.ManSingleTime ?? "") ===
            String(formData.oldManSingleTime ?? "") &&
        String(formData.ManFrequency ?? "") ===
            String(formData.oldManFrequency ?? "") &&
        String(formData.DevelopTime ?? "") ===
            String(formData.oldDevelopTime ?? "") &&
        String(formData.RobotSingleTime ?? "") ===
            String(formData.oldRobotSingleTime ?? "") &&
        String(formData.RobotMonthRun ?? "") ===
            String(formData.oldRobotMonthRun ?? "");

    if (noChange) {
        VXETable.modal.message({
            content: "变更前后数据一致，无需提交",
            status: "warning",
        });
        return;
    }

    const type = await VXETable.modal.confirm("您确定要提交该数据吗?");

    if (type === "confirm") {
        const data = getModel();
        submitting.value = true;

        proxy.$api.newPublishManageAPI
            .addPublishInfoChange(data)
            .then((res) => {
                if (res.data.Success === false) {
                    VXETable.modal.alert({
                        content: res.data.Message,
                        status: "error",
                    });
                    submitting.value = false;
                    return;
                }
                VXETable.modal.message({
                    content: "提交成功",
                    status: "success",
                });
                emit("flashPubList");
                addAuditRecord("0", "1"); //写审核日志
                visible.value = false;
                submitting.value = false;
            })
            .catch((error) => {
                VXETable.modal.message({ content: error, status: "error" });
                submitting.value = false;
                console.log(error);
            });
    }
}
function getMaxChangeCount() {
    const params = {
        uid: proxy.$store.state.userID,
        email: proxy.$store.state.email,
        currentPage: 1,
        pageSize: 1,
        searchKey: [],
    };
    proxy.$api.newPublishManageAPI
        .getPublishChangeCount(Qs.stringify(params))
        .then((res) => {
            if (res.data.Success == false) {
                console.log(res.data.Message);
                return;
            }
            maxCount.value = res.data.Data.maxCount;
        })
        .catch((error) => {
            console.log(error);
        });
}

onMounted(() => {
    getMaxChangeCount();
});

defineExpose({
    init,
});
</script>

<style scoped>
.apply-page {
    padding: 16px;
    background: #fff;
}

.notice-text {
    color: red;
}

.active {
    color: green;
}

.error {
    color: red;
}
</style>
